import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const EmailDomainSuggestions = ({
  domainPart,
  highlightedIndex,
  localPart,
  matches,
  onHighlight,
  onSelect,
}) => {
  return (
    <ul className="email-domain-suggestions" role="listbox">
      {matches.map((domain, index) => (
        <li
          aria-selected={index === highlightedIndex}
          className={cx('email-domain-suggestions__item', {
            'is-highlighted': index === highlightedIndex,
          })}
          key={domain}
          onMouseDown={event => {
            event.preventDefault();
            onSelect(domain);
          }}
          onMouseEnter={() => onHighlight(index)}
          role="option"
        >
          <span className="email-domain-suggestions__typed">
            {localPart}@{domainPart}
          </span>
          <span className="email-domain-suggestions__completion">
            {domain.slice(domainPart.length)}
          </span>
        </li>
      ))}
    </ul>
  );
};

EmailDomainSuggestions.propTypes = {
  domainPart: PropTypes.string.isRequired,
  highlightedIndex: PropTypes.number.isRequired,
  localPart: PropTypes.string.isRequired,
  matches: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHighlight: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default EmailDomainSuggestions;
